import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiButtonModule} from "@snelstart/ui-button";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-bor',
  standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
  templateUrl: './tekst-bor.component.html',
  styleUrl: './tekst-bor.component.scss',
})
export class TekstBorComponent {}
